import { useTranslation } from "react-i18next";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@tellescope/ui";
import { ChevronDown, Filter } from "lucide-react";
import { ConditionBuilder, type VisibilityCondition } from "@tellescope/visibility-conditions";

interface ItemFilterSectionProps {
  itemFilter: { condition: VisibilityCondition } | undefined;
  onChange: (condition: VisibilityCondition | undefined) => void;
  /** Already-translated description text. Caller should use t() to translate before passing. */
  description: string;
}

export function ItemFilterSection({ itemFilter, onChange, description }: ItemFilterSectionProps) {
  const { t } = useTranslation();

  return (
    <Collapsible className="border-t pt-4 mt-4">
      <CollapsibleTrigger className="flex items-center gap-2 w-full text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
        <ChevronDown className="h-4 w-4 transition-transform data-[state=open]:rotate-180" />
        <Filter className="h-4 w-4" />
        {t("Item Filter Conditions")}
        {itemFilter && <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded">{t("Active")}</span>}
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4">
        <p className="text-xs text-muted-foreground mb-3">{description}</p>
        <ConditionBuilder value={itemFilter?.condition} onChange={onChange} />
      </CollapsibleContent>
    </Collapsible>
  );
}
